<template lang="html">
    <gcmcn-layout
        title="ALL EVENTS"
        custom-class="event-view"
    >
        <el-button
            slot="action-btn"
            type="primary"
            class="gcmcn-primary-btn"
            @click="openEventCreate"
        >
            Add event
        </el-button>
        <el-row
            :gutter="26"
            class="gcmcn-separator"
            :style="{height: `calc(100vh - ( ${$store.getters.pageHeight}px))`}"
        >
            <ns-loader
                ref="ns-loader"
                :toLoad="toLoad"
                @dataFetched="onDataFetched"
            >
                <ns-loader-spinner slot="loader"></ns-loader-spinner>
                <div slot="content">
                    <el-col
                        :span="12"
                        :style="{height: `calc(100vh - ${this.$store.getters.pageHeight}px)`}"
                        style="overflow: hidden;height: 100%;"
                    >
                        <eventList
                            :events="events"
                            :universes="universes"
                            :selected-event-uid="selectedEvent ? selectedEvent.uid : ''"
                            @changeSelectedEvent="changeSelectedEvent"
                        ></eventList>
                    </el-col>
                    <el-col
                        :span="12"
                        :style="{height: `calc(100vh - ( ${$store.getters.pageHeight}px))`}"
                        style="overflow: auto;"
                    >
                        <event-form
                            v-if="displayFormView"
                            :universes="universes"
                            :event="selectedEvent"
                            @on-event-created="onEventsCreated"
                            @leave-form-view="onLeaveEventForm"
                        ></event-form>
                        <div v-else-if="selectedEvent">
                            <div class="page-title">Details</div>
                            <div class="universe-details-container gcmcn-card-gradient">
                                <ns-loader
                                    :key="selectedEvent.uid"
                                    :toLoad="toLoadRelatedEventFeeds"
                                    @dataFetched="onRelatedEventFeedsFetched"
                                >
                                    <ns-loader-spinner slot="loader"></ns-loader-spinner>
                                    <div slot="content">
                                        <eventDetails
                                            :event="selectedEvent"
                                            :relatedFeeds="relatedFeeds"
                                            @on-event-deleted="onEventDeleted"
                                            @editEvent="onEditEvent"
                                        >
                                        </eventDetails>
                                        <el-divider></el-divider>
                                        <eventRelatedFeedsList
                                            :relatedFeeds="relatedFeeds"
                                            :event="selectedEvent"
                                            :universes="universes"
                                            :events="events"
                                        >
                                        </eventRelatedFeedsList>
                                    </div>
                                </ns-loader>
                            </div>
                        </div>
                        <div v-else class="no-event-message list-empty">Please select an event</div>
                    </el-col>
                </div>
            </ns-loader>
            <eventModal ref="eventModal"></eventModal>
        </el-row>
    </gcmcn-layout>
</template>

<script>

import eventList from './eventList.vue';
import eventDetails from './eventDetails.vue';
import eventRelatedFeedsList from './eventRelatedFeedsList.vue';
import eventModal from './eventModal.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import NsLoaderSpinner from '../../partials/ns-loader-template.vue';
import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import EventForm from './event-form.vue';

export default {
    components: {
        eventList,
        eventDetails,
        eventRelatedFeedsList,
        eventModal,
        NsLoader,
        GcmcnLayout,
        NsLoaderSpinner,
        EventForm,
    },
    data () {
        return {
            activeName: 'details',
            selectedEvent: null,
            relatedFeeds: [],
            universes: [],
            events: [],
            displayFormView: false,
        };
    },
    computed: {
        toLoadRelatedEventFeeds() {
            return [
                {
                    name: 'feeds',
                    model: 'feeds',
                    filters: {
                        event_uid: this.selectedEvent.uid,
                        archived: false
                    }
                },
            ];
        },
        toLoad() {
            return [
                {
                    name: 'universes',
                    model: 'universes',
                },
                {
                    name: 'events',
                    model: 'events',
                    filters: {
                        archived: false,
                    }
                },
            ];
        },
    },
    mounted (){
    },
    methods: {
        changeSelectedEvent(event) {
            if(this.displayFormView) this.displayFormView = false;
            this.$set(this, 'selectedEvent', event);
        },
        openEventCreate() {
            this.$set(this, 'selectedEvent', null);
            this.onEditEvent();
        },
        onEditEvent() {
            this.displayFormView = true;
        },
        onDataFetched(results) {
            this.$set(this, 'universes', results.universes);
            this.$set(this, 'events', results.events);
            if(this.selectedEvent === null && this.$route.params.eventUid){
                const event = this.events.find((e) => e.uid === this.$route.params.eventUid);
                this.$set(this, 'selectedEvent', event);
                if(this.$route.params.edit){
                    this.onEditEvent();
                }
            }
        },
        onRelatedEventFeedsFetched(results) {
            this.$set(this, 'relatedFeeds', results.feeds);
        },
        onLeaveEventForm (){
            this.displayFormView = false;

        },
        onEventsCreated (){
            this.$refs['ns-loader'].triggerRefresh().then(() => {
                // pour updater le selected event apres que celui ci est était patché
                if(this.selectedEvent){
                    this.$set(this, 'selectedEvent', this.events.find((ev) => ev.uid === this.selectedEvent.uid));
                }
            });
            this.onLeaveEventForm();
        },

        onEventDeleted (cb){
            // cb permet de fermer la modale
            this.$refs['ns-loader'].triggerRefresh().then(() => {
                this.$set(this, 'selectedEvent', null);
                cb();
            });
        }
    }
};
</script>

<style lang="scss">
.event-view {
    padding-bottom: 0 !important;
    background-color: #333;
    .header-row {
        display: flex;
        align-items: center;;
        justify-content: space-between;
    }
    .eventss-title {
        color: #AAA;
    }
    .events-tabs {
        .el-tabs__item {
            color: #CCC !important;
            &.is-active {
                color: #409EFF !important;
            }
        }
    }
    .no-event-message {
        color: #CCC;
        margin-top: 40px;
    }
    .main-content {
        padding-bottom: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Events/index.vue